import { DerivationSearchFilters } from "@catalogue/data/dto/derivation.dto";
import { CatalogueRepository } from "@catalogue/data/repositories/catalogue.repository";
import { DerivationsWithTotal } from "@catalogue/domain/models/derivation.model";
import { Pagination } from "@core/domain/models/pagination";
import { inject, injectable } from "inversify";

@injectable()
export class GetAllDerivationsUseCase {
    constructor(
        @inject(CatalogueRepository)
        private readonly catalogueRepository: CatalogueRepository,
    ) {}

    async execute(
        filters?: DerivationSearchFilters,
        pagination?: Pagination,
    ): Promise<DerivationsWithTotal> {
        return this.catalogueRepository.getAllDerivations(filters, pagination);
    }
}
